<div class="body d-flex py-lg-3 py-md-2">
  <div class="container-xxl">
      <div class="row clearfix">
        <iframe height="500" [src]="paymentInvoice" title="W3Schools Free Online Web Tutorials"></iframe>
      </div>
  </div>
</div>